declare var require;

export class AnimationContents {
    public static GAME_SCREEN_JSON = require('../animate/GameScreen.json');
    public static LOADER_SCREEN_JSON = require('../animate/LoaderScreen.json');
    public static PRELOADER_SCREEN_JSON = require('../animate/PreloaderScreen.json');

    // UI
    public static INTRO_SCREEN_JSON = require('../animate/IntroScreen.json');
    public static DIFFICULTY_SCREEN_JSON = require('../animate/DifficultyScreen.json');
    public static START_SCREEN_JSON = require('../animate/StartScreen.json');
    public static RULES_SCREEN_JSON = require('../animate/RulesScreen.json');
    public static SETTINGS_SCREEN_JSON = require('../animate/Settings.json');
    public static PLAYER_CHOICE_SCREEN_JSON = require('../animate/PlayerChoiceScreen.json');
    public static RATING_SCREEN_JSON = require('../animate/RatingScreen.json');
    public static PAUSE_SCREEN_JSON = require('../animate/PauseScreen.json');
    public static GAME_END_SCREEN_JSON = require('../animate/GameEnd.json');
    public static TOOLTIP_JSON = require('../animate/Tooltip.json');
    public static POINTER_JSON = require('../animate/Pointer.json');
    public static RESTART_JSON = require('../animate/Restart.json');
    public static ACHIEVEMENTS_JSON = require('../animate/AchievementsScreen.json');
    public static MINIMAP_SCREEN_JSON = require('../animate/MiniMapScreen.json');
    public static ORIENTATION_SCREEN_JSON = require('../animate/OrientationScreen.json');
    public static FULLSCREEN_JSON = require('../animate/Fullscreen.json');
    public static SAVE_SCREEN_JSON = require('../animate/SaveScreen.json');

    // MiniGames
    public static EXCHANGE_JSON = require('../animate/CurrencyExchange.json');
    public static DINNER_JSON = require('../animate/Dinner.json');
    public static LOAN_JSON = require('../animate/LoanGame.json');
    public static CELL_JSON = require('../animate/LockCell.json');
    public static SEND_LETTER_JSON = require('../animate/SendLetter.json');
    public static ELECTRICITY_JSON = require('../animate/Electricity.json');
    public static CARDS_JSON = require('../animate/BlockCards.json');
    public static PRINT_JSON = require('../animate/PrintCard.json');
    public static BUSSINES_TRIP_JSON = require('../animate/BussinesTrip.json');
}
